module.exports = {"today":"Vandaag","clear":"Annuleer","months":{"january":"Januari","february":"Februari","march":"Maart","april":"April","may":"Mei","june":"Juni","july":"Juli","august":"Augustus","september":"September","october":"Oktober","november":"November","december":"December"},"weekdays":{"full":{"monday":"Maandag","tuesday":"Dinsdag","wednesday":"Woensdag","thursday":"Donderdag","friday":"Vrijdag","saturday":"Zaterdag","sunday":"Zondag"},"short":{"monday":"Ma","tuesday":"Di","wednesday":"Wo","thursday":"Do","friday":"Vr","saturday":"Za","sunday":"Zo"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/datepicker.json
// module id = 0w/9
// module chunks = 1